module.exports = __webpack_public_path__ + "static/media/logo_angularjs.07e3f795.svg";